module.exports = __webpack_public_path__ + "static/media/delete_icon.665926e2.svg";